import {
  formatTemplateAddress,
  formatTemplateList,
  formatTemplateTools,
} from './missionTemplateFormat';
import { formatRiskyPositions } from './missionTemplateRiskyPositions';
import { normalizePenibilite } from './templateFormData';

// Same rows, same order and same wording as the company preview.
export const SUMMARY_ROWS = [
  { key: 'name', label: 'Intitulé de la fiche', stepKey: 'activity' },
  { key: 'activity', label: 'Secteur', stepKey: 'activity' },
  { key: 'qualification', label: 'Qualification', stepKey: 'activity' },
  { key: 'tools', label: 'Matériel', stepKey: 'prerequis' },
  { key: 'licences', label: 'Permis', stepKey: 'prerequis' },
  { key: 'languages', label: 'Langue', stepKey: 'prerequis' },
  { key: 'riskyPosition', label: 'Poste à risque', stepKey: 'risk' },
  { key: 'address', label: 'Adresse', stepKey: 'locationSalary' },
  { key: 'salary', label: 'Taux horaire brut', stepKey: 'locationSalary' },
  { key: 'contact', label: 'Responsable', stepKey: 'details' },
  { key: 'other', label: 'Note intérimaire', stepKey: 'details' },
  { key: 'otherInterim', label: 'Note agence', stepKey: 'details' },
];

export const buildTemplateSummary = (form, riskyPositions) => ({
  name: form?.name,
  activity: form?.activity,
  qualification: form?.qualificationLabel,
  tools: formatTemplateTools(form?.tools),
  licences: formatTemplateList(form?.licences),
  languages: formatTemplateList(form?.languages),
  riskyPosition: formatRiskyPositions(
    {
      position_at_risk: !!form?.position_at_risk,
      penibilite: form?.position_at_risk
        ? normalizePenibilite(form?.penibilite)
        : {},
    },
    riskyPositions
  ),
  address: formatTemplateAddress(form?.location),
  salary:
    form?.salary !== undefined && form?.salary !== ''
      ? `${form.salary} € par heure${
          form.isIndexedToMinimumWage ? ' (indexé au SMIC)' : ''
        }`
      : '',
  contact: form?.contact_name
    ? `${form.contact_name}${form.contact_poste ? ` - ${form.contact_poste}` : ''}`
    : '',
  other: form?.other,
  otherInterim: form?.other_interim,
});
